import { currencyInput, defaultBooleanValue } from '@/_schemas/generic';
import { defaultStatus } from '@/_schemas/status-input';
import type { RouteListItem } from '@/types';

import type { PartnerFormSchema } from './schemas';

import { settingsBcLink } from '../../model';

export const defaultValues = {
  name: '',
  website: '',
  email: '',
  status: defaultStatus,
  code: '',
  id: -1,
  logo: null,
  logo_light: null,
  icon: null,
  // Termination & Notice Tracking defaults
  termination_notice_date: null,
  required_notice_days: null,
  override_termination_date: null,
  termination_extension_days: null,
  // Tail Commission Settings defaults
  tail_enabled: false,
  tail_percentage: null,
  tail_duration_months: null,
  tail_flat_monthly_payout: currencyInput.defaultValue(),
  tail_start_month: null,
  transition_tail_enabled: false,
  transition_tail_percentage: null,
  transition_tail_duration_months: null,
  transition_tail_start_month: null,
  calculated_termination_date: null,
  final_termination_date: null,

  handle_invoicing: defaultBooleanValue(),
} satisfies PartnerFormSchema;

export const breadcrumbsLinks: RouteListItem[] = [settingsBcLink, { path: '/settings/partners', name: 'Partners' }];
